import React from "react";
import "../styles/SlideWrapper.css";

const SlideWrapper = ({ children }) => {
  return (
    <div className="slide-wrapper">
      <div className="slide-backdrop" />
      <div className="slide-content">{children}</div>
    </div>
  );
};

export default SlideWrapper;
